<script setup>
import { computed } from 'vue';
import { useScheduleItemStore } from "@/stores/ScheduleItemStore"

const store = useScheduleItemStore()
const item = store.openModal.item
const partOf = store.openModal.partOf
const type = store.openModal.type


const closeModal = () => {
    store.setModalState(false)
}

const microCopy = computed(() => {
    return store.microcopy
})

const locationWithPrefix = () => {
    if ( type === 'ws' ) {
        const locPrefix = item.ws_location_roomnumber && item.ws_location_roomnumber !== '' ? item.ws_location_roomnumber + ' - ' : ''
        return locPrefix + item.ws_location_name
    } else if ( type === 'gs' ) {
        const locPrefix = item.gs_location_roomnumber && item.gs_location_roomnumber !== '' ? item.gs_location_roomnumber + ' - ' : ''
        return locPrefix + item.gs_location_name
    } else {
        const locPrefix = item.item_location_roomnumber && item.item_location_roomnumber !== '' ? item.item_location_roomnumber + ' - ' : ''
        return locPrefix + item.item_location_name
    }
}

const isPosterSearchResult = ( poster ) => {
    return poster.title.toLowerCase().includes(store.currentFilters.search.toLowerCase()) || poster.item_presenters_full.toLowerCase().includes(store.currentFilters.search.toLowerCase())
}

const showExtraInfo = () => {
    if ( type === 'ws' ) {
        return item.ws_extra_info && item.ws_extra_info !== '' ? item.ws_extra_info : ''
    } else if ( type === 'gs' ) {
        return item.gs_extra_info && item.gs_extra_info !== '' ? item.gs_extra_info : ''
    } else {
        return item.item_extra_info && item.item_extra_info !== '' ? item.item_extra_info : ''
    }
}


</script>
<template>
    <div
        class="sles__no-scroll-overlay"
        :class="store.modalState ? 'no-scroll' : ''"
        @click.prevent="closeModal()"
    ></div>
    <div class="sles__overlays">
        <div data-id="sles__overlay__detail" class="overlay sles__overlay sles__overlay__wrap openable open">
            <div class="sles__overlay__inner">
                <header class="sles__overlay__header">
                    <h3 class="sles__overlay__title" data-tag="title">{{ item.title }}</h3>
                    <h4 v-if="type !== 'ws' && type !== 'gs'" class="sles__overlay__presenters" :class="item.item_type === 'poster' || item.item_type === 'plenary' ? 'hidden' : ''" data-tag="presenters">{{ item.item_presenters_full }}</h4>
                </header>

                <div class="sles__overlay__body">
                    <div class="sles__overlay__meta">
                        <div v-if="type === 'ws'" class="sles__overlay__convenors with-label" data-tag="convenors" data-label="Convenors">
                            <span class="label">Convenors</span>
                            <span class="value">{{ item.ws_convenors }}</span>
                        </div>
                        <div v-if="type !== 'ws' && type !== 'gs'" class="sles__overlay__time with-label" data-tag="startat" data-label="Timing">
                            <span class="label">Timing</span>
                            <span class="value">{{ item.dayAsSlug + ' ' + item.startTimeInText }}</span>
                        </div>
                        <div v-if="type !== 'gs' && type !== 'ws'" class="sles__overlay__duration with-label" data-tag="duration" data-label="Duration">
                            <span class="label">Duration</span>
                            <span class="value"> {{ item.durationInText }} minutes</span>
                        </div>
                        <div class="sles__overlay__location with-label" data-tag="location" data-label="Location">
                            <span class="label">Location</span>
                            <span class="value">{{ locationWithPrefix() }}</span>
                        </div>
                        <div v-if="item.item_type === 'poster'" class="sles__overlay__presentations-list" data-tag="presentationsList">
                            <h4 class="presentations-list__day">Posters</h4>
                            <ul class="presentations-list__list">
                                <li v-for="(poster, ind) in item.item_poster_papers_programme" class="presentations-list__item" :key="ind">
                                    <span class="presentations-list__item__presentation" :class="store.currentFilters.search !== '' && isPosterSearchResult( poster ) ? 'poster__search-highlight' : ''" :data-abstracturl="poster.item_abstract_url">
                                        <span class="presentations-list__item__title">{{ poster.title }}</span>
                                        <span class="presentations-list__item__presenters">{{ poster.item_presenters_full }}</span>
                                        <span v-if="poster.item_abstract_url && poster.item_abstract_url !== ''" class="presentations-list__item__abstract">
                                            <a :href="poster.item_abstract_url" target="_blank" rel="noreferrer noopener">Open the abstract (pdf)</a>
                                             or 
                                            <a :href="poster.item_abstract_url" class="wp-block-file__button" download aria-describedby="sles__overlay__abstract__link">
                                                Download the abstract
                                            </a>
                                        </span>
                                    </span>
                                </li>
                            </ul>
                        </div>
                        
                    </div>
                    <div v-if="type === 'single' && ( item.item_gs && item.item_gs !== '' && item.item_gs !== false ) || ( item.item_workshop && item.item_workshop !== '' && item.item_workshop !== false )" class="sles__overlay__partof with-label" data-tag="partof" data-label="Part of ">
                        <span class="label">Part of </span>
                        <span class="value">{{ partOf }}</span>
                    </div>

                    <div v-if="showExtraInfo() !== ''" class="sles__overlay__extra" data-tag="extra" v-html="showExtraInfo()"></div>

                    <div v-if="type === 'ws'" class="sles__overlay__presentations-list" data-tag="presentationsList">
                        <div v-for="(day, index) in Object.keys(item.ws_programme)" :key="index">
                            <h4 class="presentations-list__day">{{ day }}</h4>
                            <ul class="presentations-list__list">
                                <li 
                                    v-for="(presentation, index) in item.ws_programme[day]"
                                    :key="index"
                                    class="presentations-list__item"
                                >
                                    <span class="presentations-list__item__time">{{ presentation.scheduleItem.startTimeInText }}</span>
                                    <span class="presentations-list__item__presentation">
                                        <span class="presentations-list__item__title">{{ presentation.scheduleItem.title }}</span>
                                        <span class="presentations-list__item__presenters">{{ presentation.scheduleItem.item_presenters_full }}</span>
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div v-if="type === 'gs'" class="sles__overlay__presentations-list" data-tag="presentationsList">
                        <div v-for="(day, index) in Object.keys(item.gs_programme)" :key="index">
                            <h4 class="presentations-list__day">{{ day }}</h4>
                            <ul class="presentations-list__list">
                                <li 
                                    v-for="(presentation, index) in item.gs_programme[day]"
                                    :key="index"
                                    :class="`presentations-list__item${ presentation.moderators ? '--mods' : '' }`"
                                >
                                    {{ presentation.moderators ? presentation.moderators : '' }}
                                    <span v-if="!presentation.moderators" class="presentations-list__item__time">{{ presentation.scheduleItem.startTimeInText }}</span>
                                    <span v-if="!presentation.moderators" class="presentations-list__item_presentation">
                                        <span class="presentations-list__item__title">{{ presentation.scheduleItem.title }}</span>
                                        <span class="presentations-list__item__pressenters">{{ presentation.scheduleItem.item_presenters_full }}</span>
                                    </span>
                                </li>

                            </ul> 
                        </div>
                    </div>
                    <div v-if="type === 'single' && item.item_paper" class="sles__overlay__pdf-preview" :class="item.item_type === 'poster' || item.item_type === 'break' ? 'hidden' : ''" data-tag="file">
                        <div v-if="item.item_type !== 'poster' && item.item_paper_abstract_url && item.item_paper_abstract_url !== ''" class="wp-block-file">
                            <object 
                                class="wp-block-file__embed" 
                                :data="item.item_paper_abstract_url"
                                type="application/pdf"
                                style="width:100%;height:400px"
                                aria-label="Embed of Abstract"
                            ></object>
                            <a 
                                id="sles__overlay__abstract__link"
                                :href="item.item_paper_abstract_url"
                                target="_blank"
                                rel="noreferrer noopener"
                            >{{ microCopy.sles_detail_label_open_btn }}</a>
                            <a
                                :href="item.item_paper_abstract_url"
                                class="wp-block-file__button"
                                download=""
                                aria-describedby="sles__overlay__abstract__link"
                            >{{ microCopy.sles_detail_label_download_btn }}</a>
                        </div>
                    </div>
                </div>
                <footer class="sles__overlay__footer"></footer>
            </div>
            <button 
                class="button sles__button__close-overlay"
                @click.prevent="closeModal()"
            >
                <svg class="svgicon icon-close">
                    <use xlink:href="#svg-close"></use>
                </svg>
            </button>
        </div>
    </div>
</template>